const SensorTableSkeleton: React.FC<{ rows?: number }> = ({ rows = 3 }) => {
    return (
      <tbody>
        {Array.from({ length: rows }).map((_, idx) => (
          <tr
            key={idx}
            className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200"
          >
            <td className="px-6 py-4">
              <div className="h-4 bg-gray-300 rounded w-24 animate-pulse dark:bg-gray-600"></div>
            </td>
            <td className="px-6 py-4">
              <div className="h-4 bg-gray-300 rounded w-48 animate-pulse dark:bg-gray-600"></div>
            </td>
            <td className="px-6 py-4">
              <div className="h-4 bg-gray-300 rounded w-12 animate-pulse dark:bg-gray-600"></div>
            </td>
            <td className="px-6 py-4">
              <div className="h-6 w-6 bg-gray-300 rounded-full animate-pulse dark:bg-gray-600 mx-auto"></div>
            </td>
            <td className="px-6 py-4 text-right">
              <div className="h-6 w-6 bg-gray-300 rounded-full animate-pulse dark:bg-gray-600 ml-auto"></div>
            </td>
          </tr>
        ))}
      </tbody>
    );
  };
  
export default SensorTableSkeleton